module.exports = {"520327100":"龙泉镇","520327101":"进化镇","520327102":"琊川镇","520327103":"蜂岩镇","520327104":"永和镇","520327105":"花坪镇","520327106":"绥阳镇","520327107":"土溪镇","520327108":"永安镇","520327109":"何坝镇","520327110":"天桥镇","520327111":"王寨镇","520327112":"新建镇","520327203":"石径乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520327.json
// module id = 2284
// module chunks = 0